// Merged Users workspace — combines the Users console and Retention console
// into one tabbed hub.
import React from 'react';
import HubScreen from './HubScreen';
import UsersConsole from './UsersConsole';
import RetentionConsole from './RetentionConsole';
import UserDetail from './UserDetail';

const TABS = [
  { id: 'users',     label: 'Users',       Component: UsersConsole },
  { id: 'retention', label: 'Retention',   Component: RetentionConsole },
  { id: 'lookup',    label: 'User Lookup', Component: UserDetail },
];

export default function UsersWorkspace(props) {
  return <HubScreen tabs={TABS} passProps={props} title="Users" />;
}
